/// <reference types='cordova-sqlite-storage'/>
/// <reference types='cordova-plugin-file'/>
// import 'cordova-sqlite-storage';
// import 'cordova-plugin-file';

// import { WgisService } from './wgis.service';
import { WGisBaseTool } from './wgis.tool';
import { MapCacheData } from '../core/models/mapcache';
import { Map } from 'ol';
import { Extent } from 'ol/extent';
import Feature from 'ol/Feature';
// import Layer from 'ol/layer/Layer';
// import Point from 'ol/geom/Point';
// import WKT from 'ol/format/WKT';
import { WGisEngine } from './wgis.engine';
import {
  EngineType, FieldsInterface, MapEngineOptions, BaseEngine, WGisAlignement,
  WGisServiceInterface, WGisFeatureInfo, WGisFeatureInterface, WGisToolOption
} from './wgis.utils';

import { Geometry } from 'ol/geom';
import MVT from 'ol/format/MVT';
import VectorTileLayer from 'ol/layer/VectorTile';
import { get as getProjection } from 'ol/proj';
import VectorSource from 'ol/source/Vector';
import VectorTileSource from 'ol/source/VectorTile';
import { Options as VectorTileSourceOptions } from 'ol/source/VectorTile';

import TileGrid from 'ol/tilegrid/TileGrid';
import { Tile } from 'ol';
import ImageTile from 'ol/ImageTile';
import VectorTile from 'ol/VectorTile';
import { Tile as TileLayer, Layer } from 'ol/layer';
import { XYZ } from 'ol/source';
import { Options as XyzOpts } from 'ol/source/XYZ';
import { TileCoord } from 'ol/tilecoord';
import Projection from 'ol/proj/Projection';
import { inflate, StrategyValues } from 'pako';
import { resolve } from 'url';
import { Query } from '@angular/core';
import { Style, Fill, Stroke, Text } from 'ol/style';
import { Options as StyleOptions } from 'ol/style/Style';
import { stringify } from 'querystring';
import { WgisService } from './wgis.service';
import { NumericDictionary } from 'lodash';
import { stat } from 'fs';
import { cursorTo } from 'readline';

interface CacheResurceItem {
  dbname: string;
  meta: MbtilesMeta;
  registered: boolean;
  layer: Layer;
  database: SQLitePlugin.Database;
}

interface MbtilesMeta {
  attribution: string;
  bounds: number[];
  exetent: number[];
  center: number[];
  description: string;
  maxzoom: number;
  minzoom: number;
  name: string;
  pixel_scale: number;
  format: string;
  type: string;
  version: string;
  id: string;
  basename: string;
  json: any;
}


interface CacheResurceMap {
  [source: string]: CacheResurceItem;
}

/*cordova fileplugin can copy over your files
Android default location: cordova.file.applicationStorageDirectory+"databases/your_database_name"
IOS location (with location:1 parameter) cordova.file.documentsDirectory+"your_database_name" */

interface QueryResult {
  tx: SQLitePlugin.Transaction;
  res: SQLitePlugin.Results;
}

export abstract class WGisCacheHelper {

  public static base64StringToBinary(data: string): Uint8Array {
    const raw = window.atob(data);
    const rawLength = raw.length;
    const array = new Uint8Array(new ArrayBuffer(rawLength));

    for (let i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i);
    }
    return array;
  }

  public static hexStringToBinary(hexString: string) {
    return new Uint8Array(hexString.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
  }

  public static hexTileToBinary(hex: string): Uint8Array {
    const binData: Uint8Array = new Uint8Array(hex.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
    // is gzipped
    if (binData[0] === 0x1f && binData[1] === 0x8b) {
      return inflate(binData);
    }
    return binData;
  }

  public static dbQueryP(db: SQLitePlugin.Database, params: any[], sql: string): Promise<SQLitePlugin.Results> {
    return new Promise((fulfil, reject) => {
      db.executeSql(sql, params,
        (res: SQLitePlugin.Results) => {
          // console.log('<<sql>>:' + sql + '<<' + params);
          // console.log('<<res>>:' + res.rows.length + '<<>>');
          fulfil(res);
        },
        (error: Error) => { reject(error); });
    });
  }

  public static firstQueryP(db: SQLitePlugin.Database, params: any[], sql: string): Promise<QueryResult> {
    return new Promise((fulfil, reject) => {
      db.transaction((trx: SQLitePlugin.Transaction) => {
        trx.executeSql(sql, params,
          (tx: SQLitePlugin.Transaction, res: SQLitePlugin.Results) => { fulfil({ tx, res }); },
          (tx: SQLitePlugin.Transaction, error: Error) => { reject(error); });
      });
    });
  }

  public static nextQueryP(trx: SQLitePlugin.Transaction, params: any[], sql: string): Promise<QueryResult> {
    return new Promise((fulfil, reject) => {
      trx.executeSql(sql, params,
        (tx: SQLitePlugin.Transaction, res: SQLitePlugin.Results) => {
          // console.log('<<sql>>:' + sql + '<<>>');
          // console.log('<<res>>:' + res.rows.length + '<<>>');
          fulfil({ tx, res });
        },
        (tx: SQLitePlugin.Transaction, error: Error) => { reject(error); });
    });
  }

  public static openDbP(dbname: string): Promise<SQLitePlugin.Database> {
    return new Promise((fullfil, reject) => {
      let arg: SQLitePlugin.OpenArgs;
      if(device.platform = "Android"){
        arg = {
          name: dbname,
          location: 'default'
        };
      } else if(device.platform = "iOS") {
        arg = {
          name: dbname,
          iosDatabaseLocation: 'Documents'
        };
      }
      
      try {
        const db = sqlitePlugin.openDatabase(arg);
        // console.log('<<open>>:' + dbname + '<<>>');
        fullfil(db);
      } catch (error) {
        console.error(`Error opening ${dbname}: ${error}`);
        reject(error);
      }
    });
  }

  public static mvCacheToDefaultLocation() {
    /*cordova fileplugin can copy over your files
  Android default location: cordova.file.applicationStorageDirectory+"databases/your_database_name"
  IOS location (with location:1 parameter) cordova.file.documentsDirectory+"your_database_name" */

  }

  public static vectorTileSql(c: TileCoord): string {
    // const sql = `SELECT hex(tile_data) as tile_data FROM tiles WHERE zoom_level = ${c[0]} AND tile_column = ${c[1]} AND tile_row = ${c[2]} limit 1`;
    const sql = `SELECT hex(tile_data) as tile_data 
    FROM tiles
    WHERE
    zoom_level = ${c[0]}
    AND tile_row = ${c[1]}
    AND tile_column = ${c[2]}
    limit 1`;
    return sql;
  }

  public static imageTileSql(c: TileCoord): string {
    return `SELECT CAST (tile_data as TEXT) as tile_data FROM tiles
        "WHERE zoom_level = ${c[0]} AND tile_column = ${c[1]} AND tile_row = ${c[2]}`;
  }

  public static srcImage(data: string): string {
    return 'data:image/png;base64,' + data;
  }

  public static srcEmptyImage(): string {
    return 'data:image/png;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
  }

  public static dbMeta(db: SQLitePlugin.Database): Promise<MbtilesMeta> {
    return new Promise((fullfil, reject) => {
      WGisCacheHelper.dbQueryP(db, [], 'SELECT name, value FROM metadata')
        .then((res) => {
          const meta: MbtilesMeta = {
            attribution: null, bounds: null, exetent: null,
            center: null, description: null, maxzoom: null,
            minzoom: null, name: null, pixel_scale: null,
            format: null, type: null, version: null, id: null,
            basename: null, json: null,
          };
          for (let i = 0, j = res.rows.length; i < j; i++) {
            let item = res.rows.item(i);
            switch (item.name) {
              case 'attribution': {
                meta.attribution = (item.value as string);
                break;
              }
              case 'bounds': {
                meta.bounds = (item.value as string).split(',').map((value: string, index: number) => {
                  try {
                    return parseInt(value, 10);
                  } catch (error) { return null; }
                });
                break;
              }
              case 'center': {
                meta.center = (item.value as string).split(',').map((value: string, index: number) => {
                  try {
                    return parseInt(value, 10);
                  } catch (error) { return null; }
                });
                break;
              }
              case 'description': {
                meta.description = (item.value as string);
                break;
              }
              case 'maxzoom': {
                try {
                  meta.maxzoom = parseInt((item.value as string), 10);
                } catch (error) {
                  meta.maxzoom = null;
                }
                break;
              }
              case 'minzoom': {
                try {
                  meta.minzoom = parseInt((item.value as string), 10);
                } catch (error) {
                  meta.minzoom = null;
                }
                break;
              }
              case 'name': {
                meta.name = (item.value as string);
                break;
              }
              case 'pixel_scale': {
                try {
                  meta.pixel_scale = parseInt((item.value as string), 10);
                } catch (error) {
                  meta.pixel_scale = null;
                }
                break;
              }
              case 'format': {
                meta.format = (item.value as string);
                break;
              }
              case 'type': {
                meta.type = (item.value as string);
                break;
              }
              case 'version': {
                meta.version = (item.value as string);
                break;
              }
              case 'id': {
                meta.id = (item.value as string);
                break;
              }
              case 'basename': {
                meta.basename = (item.value as string);
                break;
              }
              case 'json': {
                try {
                  meta.json = JSON.parse((item.value as string));
                } catch (error) {
                  meta.json = null;
                }
                break;
              }
            }
          }
          fullfil(meta);
        })
        .catch((err) => {
          console.error(`Failed executing sql query: ${err}`);
          console.log(err);
          reject(err);
        });
    }
    );
  }



}

abstract class BaseStyleCache {
  abstract chooser(): (feature: Feature, resolution: number) => Style;

}
interface StyleDefinition {
  stroke?: {
    color?: string,
    width?: number,
    lineDash?: number[],
  };
  fill?: {
    color?: string,
  };
  text?: {
    font?: string,
    text: string,
    scale?: number,
    color?: string,
  };
}


interface StyleRuleItem {
  val: string;
  rule?: StyleRule;
  style?: StyleDefinition;
}
interface StyleRule {
  property?: {
    name: string,
    items?: StyleRuleItem[];
    style?: StyleDefinition;
  };
  style?: StyleDefinition;
}

const WipOsmStyleDef: StyleRule = {
  property: {
    name: 'layer',
    items: [
      {
        val: 'place',
        rule: {
          property: {
            name: 'class',
            items: [
              {
                val: 'continent',
                style: {
                  text: {
                    font: 'bold 14px sans-serif',
                    text: '_name'
                  },
                }
              },
              {
                val: 'country',
                style: {
                  text: {
                    font: 'bold 14px sans-serif',
                    text: '_name'
                  },
                }
              },
              {
                val: 'state',
                style: {
                  text: {
                    font: 'bold 14px sans-serif',
                    text: '_name'
                  },
                }
              },
              {
                val: 'city',
                style: {
                  text: {
                    font: 'bold 12px sans-serif',
                    text: '_name'
                  },
                }
              },
              {
                val: 'town',
                style: {
                  text: {
                    font: 'bold 12px sans-serif',
                    text: '_name'
                  },
                }
              },
              {
                val: 'village',
                style: {
                  text: {
                    font: 'bold 10px sans-serif',
                    text: '_name'
                  },
                }
              },
              {
                val: 'hamlet',
                style: {
                  text: {
                    font: 'bold 10px sans-serif',
                    text: '_name'
                  },
                }
              },
              {
                val: 'suburb',
                style: {
                  text: {
                    font: '9px sans-serif',
                    text: '_name'
                  },
                }
              },
              {
                val: 'neighbourhood',
                style: {
                  text: {
                    font: '9px sans-serif',
                    text: '_name'
                  },
                }
              },
              {
                val: 'isolate_dwelling',
                style: {
                  text: {
                    font: '6px sans-serif',
                    text: '_name'
                  },
                }
              }
            ],
            style: {
              text: {
                font: 'bold 12px sans-serif',
                scale: 4,
                text: '_class'
              },
            },
          },
        },
      },
      {
        val: 'mountain_peak',
            style: {
              text: {
                font: 'bold 12px sans-serif',
                text: '_name'
              },
            },
      },
      {
        val: 'building',
        style: {
          fill: {
            color: '#c69d8b',
          },
          stroke: {
            color: '#0f0e0e',
            width: 0.5,
          },
          // text: {
          //   text: 'building'
          // },
        },
      },
      {
        val: 'transportation',
        rule: {
          property: {
            name: 'class',
            items: [
              {
                val: 'motorway',
                style: {
                  stroke: {
                    color: '#ea90a0',
                    width: 5
                  },
                  text: {
                  font: 'bold 12px sans-serif',
                  scale: 1,
                  text: '_class'
                  },
                }
              },
              {
                val: 'motorway_construction',
                style: {
                  stroke: {
                    color: '#ea90a0',
                    width: 5
                  },
                  text: {
                  font: 'bold 12px sans-serif',
                  scale: 1,
                  text: '_class'
                  },
                }
              },
              {
                val: 'motorway_link',
                style: {
                  stroke: {
                    color: '#ea90a0',
                    width: 5
                  },
                  text: {
                    font: 'bold 12px sans-serif',
                    scale: 1,
                    text: '_class'
                    },
                }
              },
              {
                val: 'trunk',
                style: {
                  stroke: {
                  color: '#ffb29c',
                   width: 7
                  }
                }
              },
              {
                val: 'trunk_construction',
                style: {
                  stroke: {
                  color: '#ffb29c',
                   width: 7
                  }
                }
              },
              {
                val: 'trunk_link',
                style: {
                  stroke: {
                    color: '#ffb29c',
                    width: 7
                  }
                }
              },
              {
                val: 'primary',
                style: {
                  stroke: {
                    color: '#ffd7a5',
                    width: 6
                  }
                }
              },
              {
                val: 'primary_construction',
                style: {
                  stroke: {
                    color: '#ffd7a5',
                    width: 6
                  }
                }
              },
              {
                val: 'primary_link',
                style: {
                  stroke: {
                    color: '#ffd7a5',
                    width: 6
                  }
                }
              },
              {
                val: 'secondary',
                style: {
                  stroke: {
                    color: '#f7fbbb',
                    width: 6
                  }
                }
              },
              {
                val: 'secondary_construction',
                style: {
                  stroke: {
                    color: '#f7fbbb',
                    width: 6
                  }
                }
              },
              {
                val: 'secondary_link',
                style: {
                  stroke: {
                    color: '#f7fbbb',
                    width: 6
                  }
                }
              },
              {
                val: 'tertiary',
                style: {
                  stroke: {
                    color: '#a4a4a4',
                    width: 6
                  }
                }
              },
              {
                val: 'tertiary_construction',
                style: {
                  stroke: {
                    color: '#a4a4a4',
                    width: 6
                  }
                }
              },
              {
                val: 'tertiary_link',
                style: {
                  stroke: {
                    color: '#a4a4a4',
                    width: 6
                  }
                }
              },
              {
                val: 'minor',
                style: {
                  stroke: {
                    color: '#afaeae',
                    width: 5
                  }
                }
              },
              {
                val: 'minor_construction',
                style: {
                  stroke: {
                    color: '#afaeae',
                    width: 5
                  }
                }
              },
              {
                val: 'minor_link',
                style: {
                  stroke: {
                    color: '#afaeae',
                    width: 5
                  }
                }
              },
              {
                val: 'service',
                style: {
                  stroke: {
                    color: '#afaeae',
                    width: 4
                  }
                }
              },
              {
                val: 'service_construction',
                style: {
                  stroke: {
                    color: '#afaeae',
                    width: 4
                  }
                }
              },
              {
                val: 'service_link',
                style: {
                  stroke: {
                    color: '#afaeae',
                    width: 4
                  }
                }
              },
              {
                val: 'track',
                style: {
                  stroke: {
                    color: '#b08b3d',
                    width: 1,
		                lineDash: [5, 5]
                  }
                }
              },
              {
                val: 'track_construction',
                style: {
                  stroke: {
                    color: '#b08b3d',
                    width: 1,
		                lineDash: [5, 5]
                  }
                }
              },
              {
                val: 'track_link',
                style: {
                  stroke: {
                    color: '#b08b3d',
                    width: 1,
		                lineDash: [5, 5]
                  }
                }
              },
              {
                val: 'path',
                style: {
                  stroke: {
                    color: '#b08b3d',
                    width: 1,
		                lineDash: [2, 2]
                  }
                }
              },
              {
                val: 'path_construction',
                style: {
                  stroke: {
                    color: '#b08b3d',
                    width: 1,
		                lineDash: [2, 2]
                  }
                }
              },
              {
                val: 'path_link',
                style: {
                  stroke: {
                    color: '#b08b3d',
                    width: 1,
		                lineDash: [2, 2]
                  }
                }
              },
              {
                val: 'raceway',
                style: {
                  stroke: {
                    color: '#afaeae',
                    width: 5
                  },
                  text: {
                    font: 'bold 12px sans-serif',
                    scale: 1,
                    text: '_class'
                    },
                }
              },
              {
                val: 'raceway_construction',
                style: {
                  stroke: {
                    color: '#afaeae',
                    width: 5
                  },
                  text: {
                    font: 'bold 12px sans-serif',
                    scale: 1,
                    text: '_class'
                    },
                }
              },
              {
                val: 'raceway_link',
                style: {
                  stroke: {
                    color: '#afaeae',
                    width: 5
                  },
                  text: {
                    font: 'bold 12px sans-serif',
                    scale: 1,
                    text: '_class'
                    },
                }
              },
              {
                val: 'rail',
                style: {
                  stroke: {
                    color: '#000000',
                    width: 2
                  }
                }
              },
              {
                val: 'transit',
                style: {
                  stroke: {
                    color: '#afaeae',
                    width: 5
                  },
                  text: {
                    font: 'bold 12px sans-serif',
                    scale: 1,
                    text: '_class'
                    },
                }
              },
              {
                val: 'cable_Car',
                style: {
                  stroke: {
                    color: '#afaeae',
                    width: 5
                  },
                  text: {
                    font: 'bold 12px sans-serif',
                    scale: 1,
                    text: '_class'
                    },
                }
              },
              {
                val: 'gondola',
                style: {
                  stroke: {
                    color: '#afaeae',
                    width: 5
                  },
                  text: {
                    font: 'bold 12px sans-serif',
                    scale: 1,
                    text: '_class'
                    },
                }
              },
              {
                val: 'ferry',
                style: {
                  stroke: {
                    color: '#afaeae',
                    width: 5
                  },
                  text: {
                    font: 'bold 12px sans-serif',
                    scale: 1,
                    text: '_class'
                    },
                }
              },
              {
                val: 'bridge',
                style: {
                  stroke: {
                    color: '#afaeae',
                    width: 5
                  },
                  text: {
                    font: 'bold 12px sans-serif',
                    scale: 1,
                    text: '_class'
                    },
                }
              },
              {
                val: 'pier',
                style: {
                  stroke: {
                    color: '#afaeae',
                    width: 5
                  },
                  text: {
                    font: 'bold 12px sans-serif',
                    scale: 1,
                    text: '_class'
                    },
                }
              },
              {
                val: 'unclassified',
                style: {
                  stroke: {
                    color: '#afaeae',
                    width: 5
                  },
                  text: {
                    font: 'bold 12px sans-serif',
                    scale: 1,
                    text: '_class'
                    },
                }
              },
              {
                val: 'residential',
                style: {
                  stroke: {
                    color: '#afaeae',
                    width: 5
                  },
                  text: {
                    font: 'bold 12px sans-serif',
                    scale: 1,
                    text: '_class'
                    },
                }
              },
              {
                val: 'living_street',
                style: {
                  stroke: {
                    color: '#afaeae',
                    width: 0.5
                  },
                  text: {
                    font: 'bold 12px sans-serif',
                    scale: 1,
                    text: '_class'
                    },
                }
              },
              {
                val: 'road',
                style: {
                  stroke: {
                    color: '#000000',
                    width: 0.5
                  },
                  text: {
                    font: 'bold 12px sans-serif',
                    scale: 1,
                    text: '_class'
                    },
                }
              },
            ],
          },
          //style: {
            //stroke: {
            //  color: '#a349a4',
            //  width: 1
            //},
            //text: {
              //font: 'bold 12px sans-serif',
              //scale: 1,
              //text: '_class'
            //},
          //},
      },
    },
      {
        val: 'water',
        rule: {
          property: {
            name: 'class',
            items: [
              {
                val: 'ocean',
                style: {
                  fill: {
                    color: '#add3de',
                  }
                }
              },
              {
                val: 'lake',
                style: {
                  fill: {
                    color: '#add3de',
                  }
                }
              },
              {
                val: 'river',
                style: {
                  fill: {
                    color: '#add3de',
                  }
                }
              }
            ],
            style: {
              text: {
                color: 'red',
                font: 'bold 12px sans-serif',
                scale: 4,
                text: '_class',
              },
            },
          }
        }
      },
      {
      val: 'waterway',
      rule: {
        property: {
          name: 'class',
          items: [
            {
              val: 'canal',
              style: {
                stroke: {
                  width: 4,
                  color: '#add3de',
                }
              }
            },
            {
              val: 'ditch',
              style: {
                stroke: {
                  width: 2,
                  color: '#add3de',
                }
              }
            },
            {
              val: 'drain',
              style: {
                stroke: {
                  width: 2,
                  color: '#add3de',
                }
              }
            },
            {
              val: 'river',
              style: {
                stroke: {
                  width: 4,
                  color: '#add3de',
                }
              }
            },
            {
              val: 'stream',
              style: {
                stroke: {
                  width: 2,
                  color: '#add3de',
                }
              }
            }
          ],
          style: {
            text: {
              color: '#ed1c1c',
              font: 'bold 12px sans-serif',
              scale: 4,
              text: '_class',
            },
          },
        }
      }
    },
      {
        val: 'park',
        rule: {
          property: {
            name: 'class',
            items: [
              {
                val: 'national_park',
                style: {
                  stroke: {
                    color: '#5FD064',
                    width: 2
                  },
                }
              },
              {
                val: 'nature_reserve',
                style: {
                  stroke: {
                    color: '#5FD064',
                    width: 2
                  },
                }
              },
            ],
          }
        }
      },
      {
        val: 'landuse',
        rule: {
          property: {
            name: 'class',
            items: [
              {
                val: 'railway',
                style: {
                  fill: {
                    color: '#e6d1e3',
                  },
                  stroke: {
                    color: '#b7b5b5',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'cemetery',
                style: {
                  fill: {
                    color: '#abccb1',
                  },
                  stroke: {
                    color: '#87b88d',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'military',
                style: {
                  fill: {
                    color: '#f3e4de',
                  },
                  stroke: {
                    color: '#b7b5b5',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'residential',
                style: {
                  fill: {
                    color: '#dadada',
                  },
                  stroke: {
                    color: '#b7b5b5',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'commercial',
                style: {
                  fill: {
                    color: '#eecfcf',
                  },
                  stroke: {
                    color: '#b7b5b5',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'industrial',
                style: {
                  fill: {
                    color: '#e6d1e3',
                  },
                  stroke: {
                    color: '#b7b5b5',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'retail',
                style: {
                  fill: {
                    color: '#fecac5',
                  },
                  stroke: {
                    color: '#b7b5b5',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'bus_station',
                style: {
                  fill: {
                    color: '#635f5c',
                  },
                  stroke: {
                    color: '#b7b5b5',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'school',
                style: {
                  fill: {
                    color: '#afaba8',
                  },
                  stroke: {
                    color: '#b7b5b5',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'university',
                style: {
                  fill: {
                    color: '#afaba8',
                  },
                  stroke: {
                    color: '#b7b5b5',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'kindergarten',
                style: {
                  fill: {
                    color: '#cae2c1',
                  },
                  stroke: {
                    color: '#b7b5b5',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'college',
                style: {
                  fill: {
                    color: '#695e5c',
                  },
                  stroke: {
                    color: '#b7b5b5',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'dam',
                style: {
                  fill: {
                    color: '#4ea9ea',
                  },
                  stroke: {
                    color: '#b7b5b5',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'library',
                style: {
                  fill: {
                    color: '#afaba8',
                  },
                  stroke: {
                    color: '#b7b5b5',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'hospital',
                style: {
                  fill: {
                    color: '#afaba8',
                  },
                  stroke: {
                    color: '#b7b5b5',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'stadium',
                style: {
                  fill: {
                    color: '#afaba8',
                  },
                  stroke: {
                    color: '#b7b5b5',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'pitch',
                style: {
                  fill: {
                    color: '#416209',
                  },
                  stroke: {
                    color: '#1f2f04',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'playground',
                style: {
                  fill: {
                    color: '#416209',
                  },
                  stroke: {
                    color: '#1f2f04',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'track',
                style: {
                  fill: {
                    color: '#aae0cb',
                  },
                  stroke: {
                    color: '#3f48cc',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'theme_park',
                style: {
                  fill: {
                    color: '#416209',
                  },
                  stroke: {
                    color: '#1f2f04',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'zoo',
                style: {
                  fill: {
                    color: '#416209',
                  },
                  stroke: {
                    color: '#1f2f04',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'suburb',
                style: {
                  fill: {
                    color: '#e7dfde',
                  },
                  stroke: {
                    color: '#b7b5b5',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'neighbourhood',
                style: {
                  fill: {
                    color: '#e7dede',
                  },
                  stroke: {
                    color: '#b7b5b5',
                    width: 0.1,
                  },
                }
              }
            ],
            //style: {
              //fill: {
                //color: '#1a1a1a',
              //},
              //text: {
                //color: 'red',
                //font: 'bold 12px sans-serif',
                //scale: 4,
                //text: 'class',
              //},
            //},
          }
        }
      },
      {
        val: 'landcover',
        rule: {
          property: {
            name: 'class',
            items: [
              {
                val: 'allotments',
                style: {
                  fill: {
                    color: '#cae2c1',
                  },
                  stroke: {
                    color: '#9dca8a',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'bare_rock',
                style: {
                  fill: {
                    color: '#e1dad4',
                  }
                }
              },
              {
                val: 'beach',
                style: {
                  fill: {
                    color: '#fff2bc',
                  }
                }
              },
              {
                val: 'bog',
                style: {
                  fill: {
                    color: '#d5d89f',
                  },
                  stroke: {
                    color: '#66b0e8',
                    width: 0.1,
                  },
                }
              },
              {
                val: 'dune',
                style: {
                  fill: {
                    color: '#eee3c1',
                  }
                }
              },
              {
                val: 'scrub',
                style: {
                  fill: {
                    color: '#c9d8ac',
                  }
                }
              },
              {
                val: 'farm',
                style: {
                  fill: {
                    color: '#eacca4',
                  }
                }
              },
              {
                val: 'farmland',
                style: {
                  fill: {
                    color: '#eff1d6',
                  }
                }
              },
              {
                val: 'fell',
                style: {
                  fill: {
                    color: '#ff2bc',
                  }
                }
              },
              {
                val: 'forest',
                style: {
                  fill: {
                    color: '#9dca8a',
                  },
                  stroke: {
                    color: '#8db87b',
                    width: 1,
		                lineDash: [5, 5]
                  },
                }
              },
              {
                val: 'garden',
                style: {
                  fill: {
                    color: '#cceab0',
                  }
                }
              },
              {
                val: 'glacier',
                style: {
                  fill: {
                    color: '#deeded',
                  }
                }
              },
              {
                val: 'grass',
                style: {
                  fill: {
                    color: '#ccecb2',
                  }
                }
              },
              {
                val: 'grassland',
                style: {
                  fill: {
                    color: '#ccecb2',
                  }
                }
              },
              {
                val: 'golf_course',
                style: {
                  fill: {
                    color: '#b5e2b5',
                  },
                  stroke: {
                  color: '#39ac39',
                  width: 1,
		              lineDash: [5, 5]
                  },
                }
              },
              {
                val: 'heath',
                style: {
                  fill: {
                    color: '#d6d99f',
                  }
                }
              },
              {
                val: 'marsh',
                style: {
                  fill: {
                    color: '#cfeca8',
                  },
                  stroke: {
                    color: '#65b4e9',
                    width: 0.1,
            		    lineDash: [5, 5]
                  },
                }
              },
              {
                val: 'mangrove',
                style: {
                  fill: {
                    color: '#c8d7ab',
                  },
                  stroke: {
                    color: '#65b4e9',
                    width: 0.1,
            		    lineDash: [5, 5]
                  },
                }
              },
              {
                val: 'meadow',
                style: {
                  fill: {
                    color: '#ceeca8',
                  },
                  stroke: {
                    color: '#65b4e9',
                    width: 0.1,
            		    lineDash: [5, 5]
                  },
                }
              },
              {
                val: 'orchard',
                style: {
                  fill: {
                    color: '#9edc90',
                  }
                }
              },
              {
                val: 'park',
                style: {
                  fill: {
                    color: '#e0fce3',
                  },
                  stroke: {
                    color: '#c6f1ca',
                    width: 0.1,
		                lineDash: [5, 5]
                  },
                }
              },
              {
                val: 'plant_nursery',
                style: {
                  fill: {
                    color: '#b4e4a9',
                  },
                  stroke: {
                    color: '#7eb771',
                    width: 0.1,
		                lineDash: [2, 2]
                  }
                }
              },
              {
                val: 'recreation_ground',
                style: {
                  fill: {
                    color: '#e0fce3',
                  }
                }
              },
              {
                val: 'reedbed',
                style: {
                  fill: {
                    color: '#cdebb0',
                  },
                  stroke: {
                    color: '#64b3ec',
                    width: 0.1,
		                lineDash: [2, 2]
                  },
                }
              },
              {
                val: 'saltern',
                style: {
                  fill: {
                    color: '#cdebb0',
                  },
                  stroke: {
                    color: '#64b3ec',
                    width: 0.1,
		                lineDash: [2, 2]
                  },
                }
              },
              {
                val: 'saltmarsh',
                style: {
                  fill: {
                    color: '#cdebb0',
                  },
                  stroke: {
                    color: '#64b3ec',
                    width: 0.1,
		                lineDash: [2, 2]
                  },
                }
              },
              {
                val: 'sand',
                style: {
                  fill: {
                    color: '#f3e8c6',
                  }
                }
              },
              {
                val: 'scree',
                style: {
                  fill: {
                    color: '#ede4dc',
                  }
                }
              },
              {
                val: 'swamp',
                style: {
                  fill: {
                    color: '#aed1a0',
                  },
                  stroke: {
                    color: '#5eaee8',
                    width: 0.1,
		                lineDash: [2, 2]
                  },
                }
              },
              {
                val: 'tidalflat',
                style: {
                  fill: {
                    color: '#b4c8cb',
                  },
                  stroke: {
                    color: '#4aa5fa',
                    width: 0.1,
		                lineDash: [2, 2]
                  },
                }
              },
              {
                val: 'tundra',
                style: {
                  fill: {
                    color: '#b6b690',
                  }
                }
              },
              {
                val: 'village_green',
                style: {
                  fill: {
                    color: '#ceecb2',
                  }
                }
              },
              {
                val: 'vineyard',
                style: {
                  fill: {
                    color: '#9edc90',
                  },
                  stroke: {
                    color: '#94cf86',
                    width: 0.1,
		                lineDash: [2, 2]
                  },
                }
              },
              {
                val: 'met_meadow',
                style: {
                  fill: {
                    color: '#ceecb2',
                  }
                }
              },
              {
                val: 'wetland',
                style: {
                  fill: {
                    color: '#e7ddd3',
                  },
                  stroke: {
                    color: '#6eb4f2',
                    width: 0.1,
		                lineDash: [2, 2]
                  },
                }
              },
              {
                val: 'wood',
                style: {
                  fill: {
                    color: '#9dca8a',
                  }
                }
              }
            ],
            style: {
              fill: {
                color: '#1a1a1a',
              },
              text: {
                color: 'red',
                font: 'bold 12px sans-serif',
                scale: 4,
                text: '_subclass',
              },
            },
          }
        }
      },
      {
        val: 'background',
        style: {
          fill: {
            color: '#f8f8f8'
          },
        },
      }
    ]
  }
};
class OsmStyleCache extends BaseStyleCache {
  definitions: StyleRule;
  styleCache: { [key: string]: Style; };

  constructor(def: StyleRule) {
    super();
    this.definitions = def;
    this.styleCache = {};
  }

  private createStyle(feature: Feature, st: StyleDefinition): { save: boolean, st: Style } {
    let save = true;
    const opt: StyleOptions = {};
    if (st.fill) {
      opt.fill = new Fill(st.fill);
    }
    if (st.stroke) {
      opt.stroke = new Stroke(st.stroke);
    }
    if (st.text) {
      const topt: any = {};
      for (const key in st.text) {
        if (st.text.hasOwnProperty(key)) {
          topt[key] = st.text[key];
        }
      }
      if (st.text.text[0] === '_') {
        topt.text = feature.get(st.text.text.substr(1));
        save = false;
      }
      opt.text = new Text(topt);
    }
    return { save, st: new Style(opt) };
  }

  public chooser() {
    return (feature: Feature, resolution: number): Style => {
      let cursorkey = "_";
      let cursor: StyleRule = this.definitions;
      let res: { save: boolean, st: Style };
      let style: Style = undefined;
      let navigateRule = (): Style => {
        let result: Style = undefined;
        if (cursor.style) {
          result = this.styleCache[cursorkey];
          if (result === undefined) {
            res = this.createStyle(feature, cursor.style);
            result = res.st;
            if (res.save) {
              this.styleCache[cursorkey] = result;
            }
            return result;
          }
        } else if (cursor.property) {
          const value = feature.get(cursor.property.name);
          if (cursor.property.items) {
            for (let i = 0, j = cursor.property.items.length; i < j; i++) {
              const item = cursor.property.items[i];
              if (item.val === value) {
                cursorkey = cursorkey + '.' + value;
                // console.log(cursor.property.name + ' ' + cursorkey);
                if (item.rule) {
                  cursor = cursor.property.items[i].rule;
                  // console.log('>>>undefined');
                  return undefined;
                } else if (item.style) {
                  result = this.styleCache[cursorkey];
                  if (result === undefined) {
                    res = this.createStyle(feature, item.style);
                    result = res.st;
                    if (res.save) {
                      this.styleCache[cursorkey] = result;
                    }
                  }
                  // console.log('>>>style');
                  return result;
                } else {
                  // no render
                  // console.log('>>>nul');
                  return null;
                }
              }
            }
            // default style if any
            if (cursor.property.style) {
              cursorkey = cursorkey + '_' + cursor.property.name;
              // console.log(cursor.property.name + ' ' + cursorkey);
              result = this.styleCache[cursorkey];
              if (result === undefined) {
                res = this.createStyle(feature, cursor.property.style);
                result = res.st;
                if (res.save) {
                  this.styleCache[cursorkey] = result;
                }
                // console.log('>>>default style');
                return result;
              }
            }
            // no render
            // console.log(cursor.property.name + ' non trovato ::' + value);
            // console.log('>>> null ');
            return null;
          }
        } else {
          return null;
        }
      };
      while (style === undefined) {
        style = navigateRule();
      }
      return style;
    };
  }
}

export class WGisCacheEngine extends WGisEngine implements BaseEngine {

  resources: CacheResurceItem[];
  osmstyle: BaseStyleCache;

  buildFeature(geometry: string, attribute: FieldsInterface, info: WGisFeatureInfo): WGisFeatureInterface {
    throw new Error('Method not implemented.');
  }
  feature_factory(fields: FieldsInterface, wkt: string, projection?: string): WGisFeatureInterface {
    throw new Error('Method not implemented.');
    return null;
  }
  saveSelection(): void {
    throw new Error('Method not implemented.');
  }
  clearSelection(): void {
    throw new Error('Method not implemented.');
  }
  getSelection(): void {
    throw new Error('Method not implemented.');
  }
  addFeatureToSelection(feature: Feature) {
    throw new Error('Method not implemented.');
  }
  removeFeatureFromSelection(feature: Feature) {
    throw new Error('Method not implemented.');
  }
  constructor(options: MapEngineOptions, wgisService: WGisServiceInterface) {
    super(options, wgisService);
    this.resources = [];
    this.osmstyle = new OsmStyleCache(WipOsmStyleDef);
    this.createLayer();
    this.url = 'cdvfile://localhost/persistent/';
  }

  createLayer() {
    if (this.url !== undefined) {
      const cache: CacheResurceItem = {
        dbname: this.url,
        database: undefined,
        meta: undefined,
        layer: undefined,
        registered: false,
      };
      const optsource: VectorTileSourceOptions = {};
      ///////////////////////////////////////////
      cache.layer = new VectorTileLayer({
        // renderOrder: null,
        style: this.osmstyle.chooser(),
        source: new VectorTileSource({
          // projection: 'EPSG:3857',
          // tileSize: 256,
          maxZoom: 13,
          // minZoom: 0,
          format: new MVT(),
          url: this.url,
          // tileUrlFunction: WGisCacheHelper.vectorTileSql,
        }),
      });
      this.resources.push(cache);
      ///////////////////////////////////////////

      this.registerLayer();
    } else {
      const maps = MapCacheData.get();
      const maplods: Promise<CacheResurceItem>[] = [];
      for (let i = 0, j = maps.length; i < j; i++) {
        const p = this.createCacheLayer(maps[i]);
        maplods.push(p);
        p.then((item: CacheResurceItem) => { this.resources.push(item); });
      }
      Promise.all(maplods).then((items: CacheResurceItem[]) => {
        this.oLayer = null;
        for (let i = 0, j = items.length; i < j; i++) {
          this.resources.push(items[i]);
        }
        this.registerLayer();
      });
      // this.registerLayer();
    }
  }

  createCacheLayer(dbname: string): Promise<CacheResurceItem> {
    // sqlitePlugin.openDatabase()
    return new Promise(
      (fullfil, reject) => {
        const cache: CacheResurceItem = {
          dbname,
          database: undefined,
          meta: undefined,
          layer: undefined,
          registered: false,
        };
        WGisCacheHelper.openDbP(dbname)
          .then((db) => {
            cache.database = db;
            return WGisCacheHelper.dbMeta(db);
          })
          .then((meta) => {
            cache.meta = meta;
            if (meta.format === 'pbf') {
              return this.createVectorTileLayer(cache.database, meta);
            } else {
              return this.createRasterTileLayer(cache.database, meta);
            }
          })
          .then((layer: Layer) => {
            cache.layer = layer;
            // cache.registered = false;
            fullfil(cache);
          })
          .catch((error) => { reject(error); });

      }
    );

  }


  createVectorTileLayer(db: SQLitePlugin.Database, meta: MbtilesMeta): Layer {
    const optsource: VectorTileSourceOptions = {
      //
    };
    const layer: VectorTileLayer = new VectorTileLayer({
      // renderOrder: null,
      style: this.osmstyle.chooser(),
      source: new VectorTileSource({
        projection: "EPSG:3857",
		    format: new MVT(),
        maxZoom: meta.maxzoom,
        minZoom: meta.minzoom,
        tileUrlFunction: (c) => {
          return `/${c[0]}/${c[1]}/${c[2]}.pbf`;
        },
        tileLoadFunction: (tile: any, url: string) => {
          tile.setLoader((extent, resolution, projection) => {
            const tilecoord: TileCoord = tile.getTileCoord();
            const z = tilecoord[0];
            const x = tilecoord[1];
            let y = tilecoord[2];
            y = ((1 << z)) - 1 - y;
            let sql= 'SELECT hex(tile_data) as tile_data FROM tiles WHERE zoom_level = ? AND tile_column= ? AND tile_row = ? limit 1';
            WGisCacheHelper.dbQueryP(db, [z, x, y], sql)
              .then((res) => {
                if (res['rows'].length !== 1) {
                  return;
                }
                const binData: Uint8Array = WGisCacheHelper.hexTileToBinary(res['rows'].item(0).tile_data);
                const format = tile.getFormat();
                tile.setFeatures(format.readFeatures(
                  binData, 
                  {
                    extent: extent,
                    featureProjection: projection
                  }) as Feature<Geometry>[]);
              })
              .catch((err) => { console.error(`Failed executing sql query: ${err}`); });
          });
        },
        // url: 'SELECT hex(tile_data) as tile_data FROM tiles WHERE zoom_level = ? AND tile_column= ? AND tile_row = ? limit 1',
        // tileLoadFunction: (vectorTile: VectorTile, url: string) => {
        //   // vectorTile.setLoader(function (this: VectorSource<Geometry> | VectorTile, p0: Extent, p1: number, p2: Projection) {
        //   vectorTile.setLoader(function (this: VectorTile, pextent: Extent, pres: number, pproj: Projection) {
        //     // const tilecoord: TileCoord = vectorTile.getTileCoord();
        //     const tilecoord: TileCoord = this.getTileCoord();
        //     const z = tilecoord[0];
        //     const x = tilecoord[1];
        //     let y = tilecoord[2];
        //     // flip y per conformita specifica mbtiles
        //     // tslint:disable-next-line:no-bitwise
        //     y = ((1 << z)) - 1 - y;
        //     WGisCacheHelper.dbQueryP(db, [z, x, y], url)
        //       .then((res) => {
        //         if (res.rows.length !== 1) {
        //           return;
        //         }
        //         const binData: Uint8Array = WGisCacheHelper.hexTileToBinary(res.rows.item(0).tile_data);
        //         const format = this.getFormat();
        //         vectorTile.setFeatures(format.readFeatures(binData, { extent: pextent, featureProjection: pproj }) as Feature<Geometry>[]);
        //       })
        //       .catch((err) => { console.error(`Failed executing sql query: ${err}`); });
        //   });
        // },
      }),
    });
    return layer;
  }

  createRasterTileLayer(db: SQLitePlugin.Database, meta: MbtilesMeta): Layer {
    const opt: XyzOpts = {
      projection: 'EPSG:3857',
      maxZoom: meta.maxzoom,
      minZoom: meta.minzoom,
      tileUrlFunction: WGisCacheHelper.imageTileSql,
      tileLoadFunction: (imageTile: ImageTile, uri: string) => {
        WGisCacheHelper.dbQueryP(db, [], uri).then((res) => {
          if (!res.rows.length) {
            (imageTile.getImage() as HTMLImageElement).src = WGisCacheHelper.srcEmptyImage();
          } else {
            (imageTile.getImage() as HTMLImageElement).src = WGisCacheHelper.srcImage(res.rows.item(0).tile_data);
          }
        }).catch((error) => {
          (imageTile.getImage() as HTMLImageElement).src = WGisCacheHelper.srcEmptyImage();
        });
      },
    };
    const layer = new TileLayer({
      source: new XYZ(opt)
    });
    return layer;
  }

  hide() {
    if (this.isBase && this.switcher) {
      this.switcher.hide();
    }
    for (let i = 0, j = this.resources.length; i < j; i++) {
      this.resources[i].layer.setVisible(false);
    }
  }

  /**
   * richaiamto dal
   */
  mapsChanged() {
    const maps = MapCacheData.get();
    const maplods: Promise<CacheResurceItem>[] = [];
    for (let i = 0, j = maps.length; i < j; i++) {
      const index = this.getResourceIndex(maps[i]);
      if (index === -1) {
        this.createCacheLayer(maps[i])
          .then(
            (item: CacheResurceItem) => {
              this.resources.push(item);
              this.addLayers();
            });
      }
    }

  }

  private getResourceIndex(dbname: string): number {
    for (let i = 0, j = this.resources.length; i < j; i++) {
      if (this.resources[i].dbname === dbname) {
        return i;
      }
    }
    return -1;
  }

  removeCache(id: number): Promise<boolean> {
    return new Promise<boolean>((fullfil, reject) => {
      const index = this.getResourceIndex(MapCacheData.mapname(id));
      if (index === -1) {
        fullfil(false);
      } else {
        const item: CacheResurceItem[] = this.resources.splice(index, 1);
        this.service.pMap.then(
          (map: Map) => {
            map.removeLayer(item[0].layer);
            item[0].layer.dispose();
            item[0].database.close(() => { fullfil(true); }, (err) => { reject(err); });
          }
        );
      }
    });
  }

  protected addLayers() {
    for (let i = 0, j = this.resources.length; i < j; i++) {
      if (!this.resources[i].registered) {
        this.resources[i].layer.setVisible(this.isOn);
        this.service.addLayer(this.resources[i].layer, this.zorder);
        this.resources[i].registered = true;
      }
    }
  }

  protected turnLayers(on: boolean): void {
    // TODO CHECKME
    for (let i = 0, j = this.resources.length; i < j; i++) {
      if (this.resources[i].layer !== undefined) {
        this.resources[i].layer.setVisible(on);
      }
    }
  }



}
